import { useQuery } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { GET_MERCHANT_ID_BY_ACCOUNT_NUMBER } from 'src/graphql/queries/merchants.query';

const useMerchantId = (merchantAccountNumber: string) => {
    const { data, error } = useQuery(GET_MERCHANT_ID_BY_ACCOUNT_NUMBER, {
        variables: { merchantAccountNumber },
        onError: (error) => {
            showErrorToast(error.message);
        },
    });

    return {
        id: data?.merchantByAccountNumber?.id,
        error,
    };
};

export default useMerchantId;
